import { render, staticRenderFns } from "./MultipleSidebar.vue?vue&type=template&id=64b1b36a&scoped=true"
import script from "./MultipleSidebar.vue?vue&type=script&lang=js"
export * from "./MultipleSidebar.vue?vue&type=script&lang=js"
import style0 from "./MultipleSidebar.vue?vue&type=style&index=0&id=64b1b36a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1b36a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b1b36a')) {
      api.createRecord('64b1b36a', component.options)
    } else {
      api.reload('64b1b36a', component.options)
    }
    module.hot.accept("./MultipleSidebar.vue?vue&type=template&id=64b1b36a&scoped=true", function () {
      api.rerender('64b1b36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibos/MultipleSidebar.vue"
export default component.exports